import { Breadcrumb, Col, Empty, Pagination, Radio, RadioChangeEvent, Row, Select, Space } from "antd";
import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AuctionFilter } from "../../../common/components/Index";
import '../../assets/css/styles.scss'
import { BulletedList2Icon, GridViewMediumIcon } from "@fluentui/react-icons-mdl2";
import AuctionListView from "./components/AuctionListView";
import { useLazyGetClientAuctionListQuery } from "../../redux/AuctionApi";
import { CompatClient, Stomp } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import { HomeSearchState, SocketMessage } from "../../../common/types/types";
import { AuctionResponse, AuctionSearch } from "../../types";
import { useLazySearchProductPublicQuery } from "../../../../redux/api/PublicApi";

const AuctionList = () => {
    const [listView, setListView] = useState(false);
    const [isMine, setIsMine] = useState(false);
    const [trigger, response] = useLazyGetClientAuctionListQuery();
    const [publicTrigger, publicResponse] = useLazySearchProductPublicQuery();
    const [searchPrice, setSearchPrice] = useState([-1, -1]);
    const [categories, setCategories] = useState<string[]>([]);
    const [page, setPage] = useState(1);
    const [searchDate, setSearchDate] = useState(["", ""]);
    const [searchName, setSearchName] = useState("");
    const [title, setTitle] = useState("");
    const [auctionList, setAuctionList] = useState<AuctionResponse[]>([]);
    const [startStatus, setStartStatus] = useState(0);
    const divRef = useRef<HTMLDivElement>(null);

    const location = useLocation();

    const stompClient = useRef<CompatClient>();

    useEffect(() => {
        const onError = () => {
            console.error("Websocket failed");
        }

        const onMessageReceived = (payload: any) => {
            const message: SocketMessage = JSON.parse(payload.body);
            if (message.type === "CHAT" && message.mapProductValue) {
                const id = Object.keys(message.mapProductValue)[0];
                let newAuctionList = [...auctionList];
                let itemIndex = auctionList.findIndex(item => item.productId === Number(id));
                if (itemIndex !== -1 && message.mapProductValue[id].bargainSuccess) {
                    newAuctionList[itemIndex] = {
                        ...newAuctionList[itemIndex],
                        bidderAcceptBid: {
                            valueOfBid: message.mapProductValue[id].valueOfBid
                        }
                    }
                }
                setAuctionList(newAuctionList);
            }
        }

        const onConnected = () => {
            if (stompClient.current) {
                stompClient.current.subscribe('/topic/group/bargain-product', onMessageReceived);
            }
        }

        if (location.pathname.includes("ongoing") && auctionList.length) {
            if (!stompClient.current) {
                stompClient.current = Stomp.over(function () {
                    return new SockJS(process.env.REACT_APP_API_URL + "/ws")
                });

                const headers = {
                    'X-Authorization': 'token',
                }

                stompClient.current.connect(headers, onConnected, onError);
            } else if (!stompClient.current.active) {
                stompClient.current.activate();
            }
        }

        if (location.pathname.includes("ongoing")) {
            setTitle("TÀI SẢN ĐANG ĐƯỢC ĐẤU GIÁ");
            setStartStatus(2);
        } else if (location.pathname.includes("finish")) {
            setTitle("TÀI SẢN ĐÃ KẾT THÚC ĐẤU GIÁ");
            setStartStatus(4);
        } else if (location.pathname.includes("upcoming")) {
            setTitle("TÀI SẢN SẮP ĐƯỢC ĐẤU GIÁ");
            setStartStatus(1);
        }
    }, [location.pathname, auctionList])

    useEffect(() => {
        return () => {
            if (stompClient.current && stompClient.current.active) {
                stompClient.current.deactivate();
            }
        }
    }, [])

    useEffect(() => {
        let searchState = location.state as HomeSearchState;
        if (startStatus) {
            if (startStatus !== searchState?.startStatus) {
                // Xoá tìm kiếm từ trang chủ khi rời khỏi trang hiện tại
                searchState = {};
                window.history.replaceState({}, document.title);
            }
            if (location.pathname.includes("finish")) {
                publicTrigger({
                    page: 0,
                    size: 12,
                    status: 124,
                    ...startStatus === 4 ? { startStatusList: [3, 4] } : { startStatus },
                    type: 0,
                    ...searchState?.title ? { productName: searchState?.title } : {},
                    ...searchState?.categoryCodes?.length ? { categoryCodes: searchState.categoryCodes } : {},
                })
            } else {
                trigger({
                    page: 0,
                    size: 12,
                    status: 124,
                    ...startStatus === 4 ? { startStatusList: [3, 4] } : { startStatus },
                    type: 0,
                    ...searchState?.title ? { productName: searchState?.title } : {},
                    ...searchState?.categoryCodes?.length ? { categoryCodes: searchState.categoryCodes } : {},
                })
            }

            if (searchState?.categoryCodes?.length) {
                setCategories(searchState.categoryCodes);
            } else {
                setCategories([]);
            }
            scrollToStart();
        }

        return (() => {
            window.history.replaceState({}, document.title);
        })
    }, [trigger, startStatus, location.state, location.pathname, publicTrigger])

    useEffect(() => {
        if (location.pathname.includes("finish")) {
            setAuctionList([...(publicResponse.data?.content || [])]);

        } else {
            setAuctionList([...(response.data?.content || [])]);
        }
        // scrollToStart();
    }, [location.pathname, publicResponse.data?.content, response])

    const triggerSearch = (submitValue?: AuctionSearch) => {
        if (startStatus) {
            if (location.pathname.includes("finish")) {
                publicTrigger({
                    page: page - 1,
                    size: (listView ? 6 : 12),
                    status: 124,
                    ...startStatus === 4 ? { startStatusList: [3, 4] } : { startStatus },
                    type: 0,
                    searchByUserLogin: isMine,
                    ...submitValue,
                })
            } else {
                trigger({
                    page: page - 1,
                    size: (listView ? 6 : 12),
                    status: 124,
                    ...startStatus === 4 ? { startStatusList: [3, 4] } : { startStatus },
                    type: 0,
                    searchByUserLogin: isMine,
                    ...submitValue,
                })
            }
        }
    }

    const scrollToStart = () => {
        if (divRef.current) {
            divRef.current.scrollIntoView({ behavior: 'smooth' })
        }
    }

    const onViewSelect = (e: RadioChangeEvent) => {
        setPage(1);
        setListView(e.target.value);
        triggerSearch({
            page: 0,
            size: (e.target.value ? 6 : 12),
            ...searchPrice[0] >= 0 ? { startPriceBegin: searchPrice[0] } : {},
            ...searchPrice[1] >= 0 ? { startPriceTo: searchPrice[1] } : {},
            ...categories ? { categoryCodes: categories } : {},
            ...searchDate[0] ? { fromDate: searchDate[0] } : {},
            ...searchDate[1] ? { toDate: searchDate[1] } : {},
            ...searchName ? { productName: searchName } : {},
        })
    }

    const onSwitchChange = (checked: boolean) => {
        setIsMine(checked);
        setPage(1);
        triggerSearch({ searchByUserLogin: checked, page: 0 })
        scrollToStart();
    }

    const onPageChange = (currentPage: number) => {
        setPage(currentPage);
        triggerSearch({
            page: currentPage - 1,
            ...searchPrice[0] >= 0 ? { startPriceBegin: searchPrice[0] } : {},
            ...searchPrice[1] >= 0 ? { startPriceTo: searchPrice[1] } : {},
            ...categories ? { categoryCodes: categories } : {},
            ...searchDate[0] ? { fromDate: searchDate[0] } : {},
            ...searchDate[1] ? { toDate: searchDate[1] } : {},
            ...searchName ? { productName: searchName } : {},
        })
        scrollToStart();
    }

    return (
        <div
            ref={divRef}
            style={{
                // padding: '40px calc((100vw - 1440px) / 2) 40px',
                background: "#ececec",
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                width: '100%',
                paddingTop: 40,
                paddingBottom: 40
            }}
        >
            <Space style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }} className="responsive-padding-1440">
                <Breadcrumb separator="  " className="custom-breadcrumb">
                    <Breadcrumb.Item>
                        <Link to="/">
                            Trang chủ
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        Thông tin đấu giá
                    </Breadcrumb.Item>
                </Breadcrumb>

                <div className="responsive-title">{title}</div>

            </Space>

            <div className="responsive-padding-1440">
                <Row gutter={30}>
                    <Col span={6}>
                        <AuctionFilter
                            setSearchDate={setSearchDate}
                            setSearchName={setSearchName}
                            categories={categories || []}
                            setCategories={setCategories}
                            triggerSearch={(value) => { scrollToStart(); triggerSearch(value); }}
                            setPage={setPage}
                            setSearchPrice={setSearchPrice}
                            searchDate={searchDate}
                            searchName={searchName}
                            searchPrice={searchPrice} />
                    </Col>
                    <Col span={18}>
                        <Row justify="space-between" align="middle" className="product-list-filter">
                            <Space size={20}>
                                <Radio.Group defaultValue={listView} className="filter-radio-group" onChange={(e) => onViewSelect(e)}>
                                    <Radio.Button value={true}>
                                        <BulletedList2Icon style={{ fontSize: 23 }} />
                                    </Radio.Button>
                                    <Radio.Button value={false}>
                                        <GridViewMediumIcon style={{ fontSize: 23 }} />
                                    </Radio.Button>
                                </Radio.Group>
                                <span>Số kết quả phù hợp: <span className="font-bold">{(location.pathname.includes("finish") ? publicResponse.data?.totalElements : response.data?.totalElements) || 0}</span></span>
                            </Space>
                            <Select
                                placeholder="Của tôi"
                                className="custom-select filter-select-small"
                                onChange={onSwitchChange}
                                value={isMine}
                            >
                                <Select.Option value={false}>Tất cả</Select.Option>
                                <Select.Option value={true}>Của tôi</Select.Option>
                            </Select>
                        </Row>

                        {auctionList.length ?
                            <AuctionListView
                                type={listView ? "list" : "grid"}
                                auctionList={auctionList}
                                reloadPage={triggerSearch} />
                            : <Empty description="Không có dữ liệu" />}

                        <Row justify="end" align="middle" style={{ marginTop: 35, paddingRight: 37 }}>
                            <Pagination
                                defaultCurrent={1}
                                total={(location.pathname.includes("finish") ? publicResponse.data?.totalElements : response.data?.totalElements) || 0}
                                pageSize={listView ? 6 : 12}
                                className="custom-pagination"
                                current={page}
                                onChange={onPageChange}
                                hideOnSinglePage
                                showSizeChanger={false}
                            />
                        </Row>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default AuctionList;